<template>
  <div class="layout layout--default">
    <Nav></Nav>
    <div class="site-content site-content--application">
      <Messages :context="$CONTEXTS.root" />
      <slot></slot>
    </div>
    <Footer :isVisible="isFooterVisible" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Messages from '@/components/_shared/Messages/Messages.vue'
import Nav from '@/components/Navigation/Navigation.vue'
import Footer from '@/components/Footer/Footer.vue'

export default {
  name: 'DefaultLayout',

  components: {
    Nav,
    Messages,
    Footer,
  },

  computed: {
    ...mapState('page', ['isFooterVisible']),
  },
}
</script>
